export const LYRA_SPACE = 'LYRA_SPACE';
export const UC_CLOUD = 'uc-cloud';
export const DEFAULT_PRODUCT_NAME = 'default';
